import _sectionClasses from './Page/Sections/index';
import _buttonClasses from '../DefaultButtons';
import StandardGroupView from '../1/Page/Groups/StandardGroupView';
//import OverlapGroupView from '../../Page/Groups/OverlapGroupView';

const GroupViews = {
  standard: StandardGroupView // Uses the view from template 1
  //overlap: OverlapGroupView // I don't think we need this view, so I'm commenting it out for now to see if it causes any issues.
};

export {_sectionClasses, _buttonClasses, GroupViews};
